import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SettingFragment$data } from '../../../package/src/graphql/__generated__/SettingFragment.graphql';
import { ItemTaskType, LoaderDataType, ScheduleItemType } from '../../types';

export interface IGantLoaderState {
    dataScheduleItemFromServer: LoaderDataType<ScheduleItemType>;
    dataTaskFromServer: LoaderDataType<ItemTaskType>;
    dataSettingFromServer: LoaderDataType<SettingFragment$data>;
    mappingTaskByProject: { [key: string]: ItemTaskType[] };
}

const initialState: IGantLoaderState = {
    dataScheduleItemFromServer: { rows: [], count: 0, connectionId: '' },
    dataTaskFromServer: { rows: [], count: 0, connectionId: '' },
    dataSettingFromServer: { rows: [], count: 0, connectionId: '' },
    mappingTaskByProject: {},
};

export const gantLoaderSlice = createSlice({
    name: 'gantLoader',
    initialState,
    reducers: {
        setterGantLoader: (state, action: PayloadAction<Partial<IGantLoaderState>>) => ({
            ...state,
            ...action.payload,
        }),
    },
});

export const { setterGantLoader } = gantLoaderSlice.actions;

export default gantLoaderSlice.reducer;
